<template>
  <div>
    <BasePopup v-model="isPasswordCheckPopupOpen" customClass="custom-popup mx-wd480">
      <div class="popup-header">
        <h3 class="title">비밀번호 확인</h3>
        <button type="button" class="btn-cancel" @click="handleClose"></button>
      </div>
      <div class="popup-body">
        <p class="mb36">고객님의 개인정보 보호를 위해 비밀번호를 다시 확인합니다.</p>
        <form @submit.prevent>
          <fieldset>
            <legend>비밀번호 재확인 폼</legend>
            <div class="form-box">
              <div class="form-group">
                <HconInput type="text" v-model:model-value="inputText" label="아이디" :hide-label="false" :disabled="true" inputClass="md" />
              </div>
            </div>
            <div class="form-box mt20">
              <div class="form-group" :class="{'error': isPasswordError}">
                <HconInput type="password" ref="inputPasswordRef" v-model:model-value="inputPassword" label="비밀번호" :hide-label="false" inputClass="md"/>
              </div>
              <p v-if="isPasswordError && isPasswordErrorType == 'null'" class="helper-text error">{{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"비밀번호를","입력")}}</p>
            </div>  
          </fieldset>
        </form>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box col2">
          <button type="button" @click="handleClose" class="btn btn-outline md">취소</button>
          <button type="button" @click="passwordCheck" class="btn md">비밀번호 확인</button>
        </div>
      </div>
    </BasePopup>
  </div>
</template>
<script lang="ts" setup>
import HconInput from '@/components/com/HconComPCInputField.vue';
import BasePopup from '@/components/com/HconComBasePopup.vue'
import { ref , onMounted, defineEmits} from 'vue';
import { useHconFetchBuilder } from "~/composables/hcon-fetch-builder";
import { COMMON_CODE } from '~/constants/hconMessageConstants';

// 팝업
const {showAlert} = usePopup()

const router = useRouter();

// 비밀번호 확인 팝업
const isPasswordCheckPopupOpen = ref(true)

// 부모컴포넌트로부터 받은 값
const props = defineProps<{
  isPopup?: boolean | undefined
}>()

// 팝업 닫힘
const handleClose = () => {
  isPasswordCheckPopupOpen.value = false
  emits('fail')
  // 주문서의 경우 뒤로가기 X
  if(!props.isPopup) router.back()
}

// 팝업 열림
const handleOpen = () => {
  isPasswordCheckPopupOpen.value = true
}

onMounted(async() => {
  
  // 팝업 열림
  handleOpen();

  await nextTick()

  // 비밀번호 Focus 적용
  if(inputPasswordRef.value) {
    inputPasswordRef.value.onPasswordFocus();
  }

})

// 비밀번호 확인 => 확인 시 부모컴포넌트에 넘길 값
const emits = defineEmits(['success', 'fail']);

// 사용자ID 세션 값 세팅
const userId = useHconAuthInfo().getIfPossible()?.userContext.userId;

// 아이디
const inputText = ref(userId)

// 비밀번호
const inputPassword = ref("")
const inputPasswordRef = ref<InstanceType<typeof HconInput> | null>(null)
const isPasswordError = ref(false)
const isPasswordErrorType = ref("")

// validate checkFlag
const checkFlag = ref(true);

// 비밀번호 validate 체크
const usrPasswordCheck = async () => {

isPasswordError.value = false
isPasswordErrorType.value = ""

// 비밀번호 Null 체크
if(HconCommonUtils.isEmpty(inputPassword.value)) {
  // 비밀번호 Focus 적용
  if(inputPasswordRef.value) {
    inputPasswordRef.value.onPasswordFocus();
  }
  isPasswordError.value = true
  isPasswordErrorType.value = 'null'
  return checkFlag.value = false;
}

isPasswordError.value = false
isPasswordErrorType.value = ""

return checkFlag.value = true;

}

const fetchBuilder  = useHconFetchBuilder();

// 비밀번호 확인 API 호출
const passwordCheck = async () => {

  if(await usrPasswordCheck()) {
    if(checkFlag.value == true) {
      const fetchBuilderResult = 
      await fetchBuilder.post<AjaxResult<boolean>>('/api/v1/mypage/common/userPassword-confirm')
      .body({
        currentPassword: inputPassword.value.trim()
      })
      .preventErrorNotify()
      .build()
      .execute()
      .then((result) => {
        // 비밀번호 확인이 정상적으로 이루어진 경우 호출하는 부모컴포넌트에 success 값 넘김
        if(result.resultCode == '200') {
          if(result.data == true) {
            emits('success')
          } 
        }  
      })
      .catch((error) => {
        // 응답코드가 200이 아닌경우
        if(error.resultCode != 200) {
          showAlert(error.resultMessage);
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>